import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import TrustBar from "@/components/site/TrustBar";
import StorySection from "@/components/site/StorySection";
import ProductsSection from "@/components/site/ProductsSection";
import WPModulesSection from "@/components/site/WPModulesSection";
import BenefitsSection from "@/components/site/BenefitsSection";
import HowItWorksSection from "@/components/site/HowItWorksSection";
import FAQSection from "@/components/site/FAQSection";
import FinalCTA from "@/components/site/FinalCTA";
import Footer from "@/components/site/Footer";

export default function Home() {
    return (
        <main className="relative min-h-screen overflow-x-hidden bg-background text-foreground">
            <Navbar />
            <Hero />
            <TrustBar />
            <StorySection />
            <ProductsSection />
            <WPModulesSection />
            <BenefitsSection />
            <HowItWorksSection />
            <FAQSection />
            <FinalCTA />
            <Footer />
        </main>
    );
}
